
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/netzwerk/showcase-map",
      function () {
        return require("private-next-pages/netzwerk/showcase-map.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/netzwerk/showcase-map"])
      });
    }
  